$(document).ready(function() {
	
	var checkBoxes = 'input[name="person"],input[name="company"],input[name="gov"]';
	
	//check all checkboxes when the page is loaded without search criteria
	if (!$(checkBoxes).is(':checked')) {
		$('input[name="person"]').prop('checked', true);
		$('input[name="company"]').prop('checked', true);
		$('input[name="gov"]').prop('checked', true);
	}
	
	//20181206:temporary fix, minifier is not working at the moment and the autocomplete is not ready at this point
	setTimeout(function() {
		determineType();
	}, 1);

	$(checkBoxes).change(function () {
		determineType();
	});
	
	// submit form when a category is selected through the dropdowns
	$('.category_form select').on('change', function(){
		$(this).closest('form').submit();
	});
	
	// show extra details when the user clicks on the name
	$('.showDetailsPerson').click(function(e) {
		//add content
		addTitle($(this).text());
		addSubTitle('CONTACTGEGEVENS');
		var info = $(this).closest('tr').data();
		addLabelAndValue('Telefoonnummer:',info['phone_number']);
		addLabelAndValue('Mobiel telefoonnummer:',info['mobile_phone_number']);
		addLabelAndValue('Prive telefoonnummer:',info['private_phone_number']);
		addLabelAndValue('E-mail:',info['email']);
		addLabelAndValue('Prive e-mail:',info['private_email']);
		addSubTitle('WERKZAAM BIJ');
		addValue(info['company_name']);
		addValue(info['company_work_field']);
		addValue(info['company_postal_address']);
		addValue(info['company_zip_code']+' '+info['company_city']);
		
		displayDetails();
	});
	$('.showDetailsCompany').click(function(e) {
		//add content
		var info = $(this).closest('tr').data();
		addTitle($(this).text());
		addValue(info['company_work_field']);
		addValue(info['company_postal_address']);
		addValue(info['company_zip_code']+' '+info['company_city']);
		addSubTitle('CONTACTGEGEVENS');
		addLabelAndValue('Telefoonnummer:',info['phone_number']);
		addLabelAndValue('E-mail:',info['email']);
		addLabelAndValue('Website:',info['website']);

		displayDetails();
	});
	$('.showDetailsGov').click(function(e) {
		//add content
		var info = $(this).closest('tr').data();
		addTitle($(this).text());
		addValue(info['department']);
		addValue(info['postaladdress']);
		addValue(info['zip_code']+' '+info['city']);
		addSubTitle('CONTACTGEGEVENS');
		addLabelAndValue('Telefoonnummer:',info['phone_number']);
		addLabelAndValue('E-mail:',info['email']);
		addLabelAndValue('Website:',info['website']);
		
		displayDetails();
	});
	
	// hide modal window
	$('#detailBackground').click(function () {
		closeDetails();
	});
	// use event delegation because this element is added dinamically
	$('#detailContainer').on('click', '#detailClose', function () {
		closeDetails();
	});
	// close popup when ESC is pressed
	$(document).keyup(function (e) {
		if (e.keyCode == 27) { //esc
			if ($('#detailContainer').css('display') != 'none') {
				closeDetails();
				e.preventDefault();
			}
		}
	});
	
});


// Append subtitle to the modal window
function addTitle(title) {
	$('#detailContainer').append('<div id="detailTitle">'+
	                             '<a id="detailClose">&#10005;</a>'+
	                             '<span>'+title+'</span>'+
	                             '</div>');
}


// Append subtitle to the modal window
function addSubTitle(title) {
	$('#detailContainer').append('<div id="detailSubTitle">'+title+'</div>');
}


// Append a row to the modal window
function addValue(value) {
	if (value == '') return;
	$('#detailContainer').append('<div>'+
	                             '<div class="detailValue">'+value+'</div>'+
	                             '</div>');
}


// Append a row composed of a label and a value to the modal window
function addLabelAndValue(label, value) {
	if (value == '') return;
	$('#detailContainer').append('<div>'+
	                             '<div class="detailLabel">'+label+'</div>'+
	                             '<div class="detailValue">'+value+'</div>'+
	                             '</div>');
}


// Container/modal window for showing details on click
function displayDetails() {
	// calculate position
	var left = $(window).width()/2 - $('#detailContainer').outerWidth(true)/2;
	var top = $(window).height()/2 - $('#detailContainer').outerHeight(true)/2;
	$('#detailContainer').css('left', left+'px');
	$('#detailContainer').css('top', top+'px');
	//show popup
	$('#detailContainer').fadeIn(100);
	$('#detailBackground').fadeIn(100);
}


// Destroy child elements of the modal window and hide it
function closeDetails() {
	$('#detailBackground').fadeOut(100);
	$('#detailContainer').fadeOut(100, function () {
		$('#detailContainer').empty(); // Removes all child elements
	});
}


// URL for ajax request must change when a checkbox is unchecked
function determineType() {
	
	var checkBoxes = 'input[name="person"],input[name="company"],input[name="gov"]';
	var type = 'person|company|gov'; // not used for db search so '=person' is not needed
	
	if (!$('input[name="person"]').is(':checked')) {
		if (!$('input[name="company"]').is(':checked') && $('input[name="gov"]').is(':checked')) {
			type = 'gov';
		}
		if (!$('input[name="gov"]').is(':checked') && $('input[name="company"]').is(':checked')) {
			type = 'company';
		}
		if ($('input[name="company"]').is(':checked') && $('input[name="gov"]').is(':checked')) {
			type = 'company|gov';
		}
	}

	if (!$('input[name="company"]').is(':checked')) {
		if (!$('input[name="gov"]').is(':checked') && $('input[name="person"]').is(':checked')) {
			type = 'person';
		}
		if ($('input[name="gov"]').is(':checked') && $('input[name="person"]').is(':checked')) {
			type = 'person|gov';
		}
	}
	
	if (!$('input[name="gov"]').is(':checked')) {
		if ($('input[name="person"]').is(':checked') && $('input[name="company"]').is(':checked')) {
			type = 'person|company';
		}
	}
	
	$('#searchSoundGuide').data().autocompleter.options.extraParams['type'] = type;
}

// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
